import React, { useEffect, useState } from "react";
import { useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

// Components
import Header from "../layout/Header";
import Alert from "../components/Alert";
import HeroSection from "../components/landing/HeroSection";
import FeaturesSection from "../components/landing/FeaturesSection";
import PricingSection from "../components/landing/PricingSection";
import ContactForm from "../components/landing/ContactForm";
import Footer from "../layout/Footer";
import OurProcess from "../components/landing/OurProcess";
// import PainPointsSection from "../components/landing/PainPointsSection";

// Assets
import heroImage from "../../../assets/images/hero-image.jpg";

const LandingPage = () => {
  const [showContactForm, setShowContactForm] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [initialMessage, setInitialMessage] = useState("");

  // Animation controls
  // const controls1 = useAnimation();
  const controls2 = useAnimation();
  const controls3 = useAnimation();
  const controls4 = useAnimation();
  const controls5 = useAnimation();
  const controls6 = useAnimation();
  // Refs for scroll animations
  // const [ref1, inView1] = useInView({ threshold: 0.3, triggerOnce: true });
  const [ref2, inView2] = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });
  const [ref3, inView3] = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });
  const [ref4, inView4] = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });
  const [ref5, inView5] = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });
  const [ref6, inView6] = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });

  // Trigger animations when sections come into view
  useEffect(() => {
    // if (inView1)
    //   controls1.start({ opacity: 1, y: 0, transition: { duration: 0.5 } });
    if (inView2)
      controls2.start({ opacity: 1, x: 0, transition: { duration: 0.5 } });
    if (inView3)
      controls3.start({ opacity: 1, x: 0, transition: { duration: 0.5 } });
    if (inView4)
      controls4.start({ opacity: 1, x: 0, transition: { duration: 0.5 } });
    if (inView5)
      controls5.start({ opacity: 1, x: 0, transition: { duration: 0.5 } });
    if (inView6)
      controls6.start({ opacity: 1, y: 0, transition: { duration: 0.5 } });
  }, [
    // inView1,
    inView2,
    inView3,
    inView4,
    inView5,
    inView6,
    // controls1,
    controls2,
    controls3,
    controls4,
    controls5,
    controls6,
  ]);

  const handleGetStarted = () => {
    const pricingSection = document.getElementById("pricing");
    pricingSection?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-white pt-20">
      <Header mainText="" showLandingNav={true} />

      {/* Hero Section */}
      <HeroSection
        handleGetStarted={handleGetStarted}
        setShowContactForm={setShowContactForm}
        heroImage={heroImage}
      />

      {/* Pain Points Section */}
      {/* <PainPointsSection ref1={ref1} controls1={controls1} /> */}

      {/* Our Process Section */}
      <OurProcess ref2={ref2} controls2={controls2} />

      {/* Features Section */}
      <div id="features">
        <FeaturesSection
          ref3={ref3}
          ref4={ref4}
          ref5={ref5}
          controls3={controls3}
          controls4={controls4}
          controls5={controls5}
        />
      </div>

      {/* Animated Gradient Divider */}
      <div className="relative h-24 -mb-24 overflow-hidden w-full">
        <div className="w-4/6 mx-auto h-1.5 top-1/2 transform -translate-y-1/2 overflow-hidden">
          <div className="w-[200%] h-full bg-gradient-to-r from-peachYellow via-coralRed to-roseBrown animate-drift"></div>
        </div>
      </div>

      {/* Pricing Section */}
      <div id="pricing">
        <PricingSection
          ref6={ref6}
          controls6={controls6}
          setShowContactForm={setShowContactForm}
          setInitialMessage={setInitialMessage}
        />
      </div>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-primary text-ashGray font-sans">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to Transform Your Hiring Process?
          </h2>
          <p className="text-xl max-w-3xl mx-auto mb-10">
            Join hundreds of companies already using our platform to find the
            best talent faster and more efficiently.
          </p>
          <button
            onClick={() => setShowContactForm(true)}
            data-testid="open-contact-form"
            className="bg-white text-ashGray hover:bg-white/90 font-bold py-3 px-8 rounded-md transition-colors"
          >
            Get Started Today
          </button>
        </div>
      </section>

      {/* Footer */}
      <Footer setShowContactForm={setShowContactForm} />

      {/* Contact Form Modal */}
      <ContactForm
        showContactForm={showContactForm}
        setShowContactForm={setShowContactForm}
        formSubmitted={formSubmitted}
        setFormSubmitted={setFormSubmitted}
        setAlertMessage={setAlertMessage}
        setShowAlert={setShowAlert}
        setAlertType={setAlertType}
        initialMessage={initialMessage}
      />

      {/* Alert */}
      <Alert
        title={alertType === "success" ? "Success" : "Error"}
        message={alertMessage}
        showAlert={showAlert}
        setShowAlert={setShowAlert}
        colorClass={alertType}
      />
    </div>
  );
};

export default LandingPage;
